class Article extends HTMLElement {
    constructor() {
        super();

        this.timeCount();

        this.setArticles();

        // this.addEventListener('scroll', this.ScrollIndicator.bind(this))

        window.onscroll = function () {
            ScrollIndicator();
        };

        function ScrollIndicator() {
            var winScroll =
                document.body.scrollTop || document.documentElement.scrollTop;
            var height =
                document.documentElement.scrollHeight -
                document.documentElement.clientHeight;
            var scrolled = (winScroll / height) * 110;
            document.querySelector(".article__progress").style.width = scrolled + "%";
        }

        this.findAllTitle();

        this.removeBrTags();
    }

    removeBrTags() {


        document.querySelectorAll(".sommaire__link").forEach(function (elem) {
            elem.innerHTML = elem.innerHTML.replaceAll("&lt;br&gt;", "");
        });
        document.querySelectorAll(".sommaire__link").forEach(function (elem) {
            elem.innerHTML = elem.innerHTML.replaceAll("&lt;span&gt;", "");
            elem.innerHTML = elem.innerHTML.replaceAll("&lt;/span&gt;", "");
        });

        document.querySelectorAll(".sommaire__link").forEach(function (elem) {
            elem.innerHTML = elem.innerHTML.replaceAll("&lt;strong&gt;", "");
            elem.innerHTML = elem.innerHTML.replaceAll("&lt;/strong&gt;", "");
        });

        document.querySelectorAll(".sommaire__link").forEach(function (elem) {
            elem.innerHTML = elem.innerHTML.replaceAll("&lt;b&gt;", "");
            elem.innerHTML = elem.innerHTML.replaceAll("&lt;/b&gt;", "");
        });
        document.querySelectorAll(".sommaire__link").forEach(function (elem) {
            elem.innerHTML = elem.innerHTML.replaceAll("&nbsp;", "");
        });
        document.querySelectorAll(".sommaire__link").forEach(function (elem) {
            elem.innerHTML = elem.innerHTML.replaceAll("&lt;i&gt;", "");
            elem.innerHTML = elem.innerHTML.replaceAll("&lt;/i&gt;", "");
        });
        document.querySelectorAll(".sommaire__link").forEach(function (elem) {
            elem.innerHTML = elem.innerHTML.replaceAll('&lt;span style="font-weight: 400;"&gt;', '');
        });
    }

    getRandomIndices(length) {
        let index1 = Math.floor(Math.random() * length);
        let index2;

        do {
            index2 = Math.floor(Math.random() * length);
        } while (index2 === index1);

        return [index1, index2];
    }

    setArticles() {
        const articles = [];
        document.querySelectorAll(".recommended__article").forEach((article) => {
            articles.push(article);
        });
        let [randomIndex1, randomIndex2] = this.getRandomIndices(articles.length);
        this.querySelector(".article__recommended-list").innerHTML = "";
        for (let i = 0; i < articles.length; i++) {
            if (i === randomIndex1 || i === randomIndex2) {
                this.querySelector(".article__recommended-list").append(articles[i]);
                document.querySelectorAll(".recommended__article").forEach((srt) => {
                    srt.classList.add("recommended__article-show");
                });
            }
        }
    }

    initEvents() {
        document.querySelectorAll(".sommaire__link").forEach((button) => {
            button.addEventListener("click", this.buttonScrollTo.bind(this));
        });
    }
    // bar progress on scroll
    timeCount() {
        var myString = document.querySelector(".article__content").innerHTML;
        var myArray = myString.split(" ");

        let time = myArray.length / 175;
        this.querySelector(".article__time-nb").innerHTML = Math.ceil(time);
    }

    findAllTitle() {
        let titles = [];

        let id = 0;

        const content = document.querySelector(".article__content");
        let sommaire = document.querySelector(".article__table-sommaire");

        content.querySelectorAll("h3").forEach((elem) => {
            elem.classList.add(`content-h3`);
        });

        content.querySelectorAll("h3, h2").forEach((elem) => {
            elem.classList.add(`title${id}`);

            if (elem.classList.contains("content-h3")) {
                let nouvelElement = {
                    title: elem,
                    booleanValue: true,
                };
                id += 1;
                titles.push(nouvelElement);
            } else {
                let nouvelElement = {
                    title: elem,
                    booleanValue: false,
                };
                id += 1;
                titles.push(nouvelElement);
            }
        });

        for (var i = 0; i < titles.length; i++) {
            var li = document.createElement("li");
            var div = document.createElement("div");
            div.setAttribute("data-info", i);
            div.classList.add("sommaire__link");
            if (titles[i].booleanValue == true) {
                div.classList.add("sommaire__link-h3");
            }
            div.textContent = titles[i].title.innerHTML;
            li.appendChild(div);
            sommaire.appendChild(li);
        }

        this.initEvents();
    }

    buttonScrollTo(e) {
        let currentLink = e.currentTarget;

        let currentId = currentLink.dataset.info;

        console.log(currentId);
        var cur = document.querySelector(`.title${currentId}`);

        // element.scrollIntoView({ block: "start", inline: "end" });

        const windowHeight =
            window.innerHeight || document.documentElement.clientHeight;

        const goodheight = (windowHeight / 195) * 100;

        const element = cur.offsetTop + goodheight - 100;

        console.log(goodheight);

        window.scrollTo({
            top: element,
            behavior: "smooth",
        });
    }
}

customElements.define("article-js", Article);
